import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/model/fetchDependenciesService.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createEvent, createStore, guard, merge, restore, sample } from 'effector';
import * as api from '@gmini/sm-api-sdk';
import { isNotEmpty } from '@gmini/utils';
import { isBaseClassifierNode } from "../../../classifier-service/Node";
import { getNode } from "../../../classifier-service";
import { buildIdVersionKey } from "./buildIdVersionKey";
export function createFetchDependenciesService(_ref) {
  var entity$ = _ref.entity$,
      fetchedClassifiers = _ref.fetchedClassifiers,
      entityUpdated = _ref.entityUpdated,
      reset = _ref.reset,
      nodes$ = _ref.nodes$;
  var fetchOnce = createEvent({
    name: "fetchOnce",
    sid: "-f1ci1c"
  });
  var removeCls = createEvent({
    name: "removeCls",
    sid: "-xmx2dx"
  });
  var entityUpdates = entity$.updates.filter({
    fn: isNotEmpty
  }).map(function (_ref2) {
    var id = _ref2.id,
        version = _ref2.version;
    return {
      classifierId: id,
      classifierVersion: version
    };
  });
  var fetchTrigger = merge([api.UserClassifier.fetch.trigger, api.AssemblyClassifier.fetch.trigger, api.BaseClassifier.Populated.fetch.trigger], {
    name: "fetchTrigger",
    sid: "76jehe"
  });
  var sourceClassifiersLoaded$ = createStore({}, {
    name: "sourceClassifiersLoaded$",
    sid: "-5a2zsk"
  }).on(fetchTrigger, function (state, cls) {
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, buildIdVersionKey(cls), false));
  }).on(fetchedClassifiers, function (state, dependencies) {
    var currentCls = entity$.getState();

    if (!currentCls) {
      return state;
    }

    var sourceClsLoaded = dependencies.filter(function (node) {
      return currentCls.sourceClassifiers.some(function (sourceCls) {
        return sourceCls.id === node.id && sourceCls.type === node.type;
      });
    }).reduce(function (acc, next) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, buildIdVersionKey(next), true));
    }, {});
    return _objectSpread(_objectSpread({}, state), sourceClsLoaded);
  }).on(removeCls, function (oldState, key) {
    var state = _objectSpread({}, oldState);

    delete state[key];
    return state;
  }).reset(reset);
  var setInitialFetch = createEvent({
    name: "setInitialFetch",
    sid: "ulatrc"
  });
  var initialFetch$ = restore(setInitialFetch, true, {
    name: "initialFetch$",
    sid: "-y2s75t"
  }).reset(reset);
  var updateClsEvent = sample({
    ɔ: [{
      clock: entityUpdated.filter({
        fn: isNotEmpty
      }),
      source: sourceClassifiersLoaded$,
      fn: function fn(loadedClassifiers, updatedClassifier) {
        return {
          loadedClassifiers: loadedClassifiers,
          updatedClassifier: updatedClassifier
        };
      }
    }],
    config: {
      name: "updateClsEvent",
      sid: "-ftc7jt"
    }
  });
  guard({
    ɔ: [{
      clock: entityUpdates,
      filter: initialFetch$.map(function (value) {
        return value;
      }),
      target: fetchOnce
    }],
    config: {
      sid: "-m2nksr"
    }
  });
  fetchOnce.watch(function (clsData) {
    setInitialFetch(false);
    api.UserClassifier.fetchFlatListDependencies.defaultContext(clsData);
    api.UserClassifier.fetchFlatListItems.defaultContext(clsData);
  });
  updateClsEvent.watch(function (_ref3) {
    var updatedClassifier = _ref3.updatedClassifier,
        loadedClassifiers = _ref3.loadedClassifiers;
    var removedClassifiers = Object.keys(loadedClassifiers).filter(function (key) {
      return !updatedClassifier.sourceClassifiers.some(function (cls) {
        return key === buildIdVersionKey(cls);
      });
    });
    var clsAdded = updatedClassifier.sourceClassifiers.some(function (cls) {
      return !loadedClassifiers[buildIdVersionKey(cls)];
    });
    var dependenciesChanged = clsAdded || !!removedClassifiers.length;

    if (dependenciesChanged) {
      api.UserClassifier.fetchFlatListDependencies.defaultContext({
        classifierId: updatedClassifier.id,
        classifierVersion: updatedClassifier.version
      });
    }

    removedClassifiers.forEach(removeCls);
  });
  sample({
    ɔ: [{
      clock: fetchedClassifiers,
      source: entity$,
      fn: function fn(entity, fetchedClassifiers) {
        return fetchedClassifiers.filter(function (cls) {
          return entity === null || entity === void 0 ? void 0 : entity.sourceClassifiers.some(function (sourceCls) {
            return sourceCls.id === cls.id;
          });
        }).filter(isBaseClassifierNode);
      }
    }],
    config: {
      sid: "-kk7y20"
    }
  }).watch(function (baseClassifiers) {
    baseClassifiers.forEach(function (baseCls) {
      baseCls.children.forEach(function (ref) {
        var modelRef = getNode(nodes$.getState(), ref);

        if (!modelRef) {
          return;
        }

        api.BimModel.fetchLatestBimFile.defaultContext.submit({
          modelId: modelRef.element.id,
          projectUrn: baseCls.projectUrn
        });
      });
    });
  });
  return {
    sourceClassifiersLoaded$: sourceClassifiersLoaded$
  };
}